import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { UIModule } from './ui/ui.module';
import { NavBarButtonComponent } from './nav-bar-template/nav-bar-button/nav-bar-button.component';
import { NavBarSplitButtonComponent } from './nav-bar-template/nav-bar-split-button/nav-bar-split-button.component';
import { NavBarTemplateComponent } from './nav-bar-template/nav-bar-template.component';
import { PasswordInputComponent } from './password-input/password-input.component';
import { LoginCardComponent } from './login/login-card/login-card.component';
import { PageComponent } from './page/page.component';

import { AdminGuard } from './guards/admin.guard';
import { AuthGuard } from './guards/auth.guard';
import { LoginGuard } from './guards/login.guard';

import { AuthService } from './services/auth.service';
import { MedicationService } from './services/medication.service';
import { PatientService } from './services/patient.service';
import { UserService } from './services/user.service';
import { ToastService } from './services/toast.service';

@NgModule({
  declarations: [
    NavBarTemplateComponent,
    NavBarButtonComponent,
    NavBarSplitButtonComponent,
    PageComponent,
  ],
  imports: [CommonModule, FormsModule, ReactiveFormsModule, UIModule, RouterModule,
    LoginCardComponent,
    PasswordInputComponent,
  ],
  exports: [
    NavBarTemplateComponent,
    NavBarButtonComponent,
    NavBarSplitButtonComponent,
    UIModule,
    PasswordInputComponent,
    LoginCardComponent,
  ],
  providers: [
    AdminGuard,
    AuthGuard,
    LoginGuard,

    AuthService,
    MedicationService,
    PatientService,
    UserService,
    ToastService,
  ],
})
export class CalvinEMRSharedModule { }
